import { SxProps, Theme } from '@mui/material';
import { IconButtonOwnProps } from '@mui/material/IconButton';
import React from 'react';

import { globalEnums, globalTypes } from '@/shared/duck';

import { BasicMenu } from './basic';
import { ComplexMenu } from './complex';

export interface UIMenuProps {
  itemList: globalTypes.MenuItemList[];
  type?: globalEnums.EMenuType;
  disabled?: boolean;
  iconButtonColor?: IconButtonOwnProps['color'];
  iconButtonSize?: IconButtonOwnProps['size'];
  headerText?: string;
  headerSubText?: string;
  headerIconC?: React.ReactElement;
  footerItems?: globalTypes.MenuItemList[];
  menuIconC?: React.ReactElement;
  sx?: SxProps<Theme>;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const UIMenu: React.FC<UIMenuProps> = ({
  type = globalEnums.EMenuType.BASIC,
  itemList,
  disabled,
  headerText,
  headerSubText,
  headerIconC,
  footerItems,
  iconButtonColor,
  iconButtonSize,
  menuIconC,
  sx,
  setIsOpen,
}) => {
  return (
    <>
      {(
        () => {
          switch (type) {
            case globalEnums.EMenuType.BASIC:
              return (
                <BasicMenu
                  itemList={itemList}
                  disabled={disabled}
                  iconButtonColor={iconButtonColor}
                  iconButtonSize={iconButtonSize}
                  menuIconC={menuIconC}
                  sx={sx}
                  setIsOpen={setIsOpen}
                />
              );
            case globalEnums.EMenuType.COMPLEX:
              return (
                <ComplexMenu
                  itemList={itemList}
                  disabled={disabled}
                  headerText={headerText}
                  headerSubText={headerSubText}
                  headerIconC={headerIconC}
                  footerItems={footerItems}
                  iconButtonColor={iconButtonColor}
                  iconButtonSize={iconButtonSize}
                  menuIconC={menuIconC}
                  sx={sx}
                  setIsOpen={setIsOpen}
                />
              );
          }
        }
      )()}
    </>
  );
};

export default UIMenu;